import { render } from "./MainNavbar.vue?vue&type=template&id=543be11e&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=543be11e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-543be11e"

export default script